<template>
  <dl class="gap-y-4 grid" style="grid-template-columns: fit-content(10rem) 1fr">
    <template v-for="({ label, text, url }, i) in data" :key="i">
      <dt class="fw-bold pr-2">
        {{ label }}:
      </dt>
      <dd>
        <base-link v-if="url" :to="url">
          {{ text }}
        </base-link>
        <span v-else>
          {{ text }}
        </span>
      </dd>
    </template>
  </dl>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
}>()
</script>
